import ExpensePage from "@/app/(app)/(crew)/supervising/[shift]/expense";

export default ExpensePage;
